/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CrmProjectIntegrationResourceData
 */
export interface CrmProjectIntegrationResourceData {
    /**
     * 
     * @type {string}
     * @memberof CrmProjectIntegrationResourceData
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmProjectIntegrationResourceData
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof CrmProjectIntegrationResourceData
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmProjectIntegrationResourceData
     */
    remoteId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CrmProjectIntegrationResourceData
     */
    enabled?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof CrmProjectIntegrationResourceData
     */
    removedAt?: Date | null;
}

/**
 * Check if a given object implements the CrmProjectIntegrationResourceData interface.
 */
export function instanceOfCrmProjectIntegrationResourceData(value: object): value is CrmProjectIntegrationResourceData {
    return true;
}

export function CrmProjectIntegrationResourceDataFromJSON(json: any): CrmProjectIntegrationResourceData {
    return CrmProjectIntegrationResourceDataFromJSONTyped(json, false);
}

export function CrmProjectIntegrationResourceDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CrmProjectIntegrationResourceData {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] === undefined ? undefined : json['id'] === null ? null : json['id'],
        'type': json['type'] == null ? undefined : json['type'],
        'name': json['name'] === undefined ? undefined : json['name'] === null ? null : json['name'],
        'remoteId': json['remoteId'] === undefined ? undefined : json['remoteId'] === null ? null : json['remoteId'],
        'enabled': json['enabled'] === undefined ? undefined : json['enabled'] === null ? null : json['enabled'],
        'removedAt': json['removedAt'] === undefined ? undefined : json['removedAt'] === null ? null : (new Date(json['removedAt'])),
    };
}

export function CrmProjectIntegrationResourceDataToJSON(json: any): CrmProjectIntegrationResourceData {
    return CrmProjectIntegrationResourceDataToJSONTyped(json, false);
}

export function CrmProjectIntegrationResourceDataToJSONTyped(value?: CrmProjectIntegrationResourceData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'type': value['type'],
        'name': value['name'],
        'remoteId': value['remoteId'],
        'enabled': value['enabled'],
        'removedAt': value['removedAt'] == null ? value['removedAt'] : value['removedAt'].toISOString(),
    };
}

